__turbopack_context__.v({
  "checkbox": "I55GwW_checkbox",
  "checkboxRow": "I55GwW_checkboxRow",
  "inner": "I55GwW_inner",
  "input": "I55GwW_input",
  "label": "I55GwW_label",
  "outer": "I55GwW_outer",
  "pickupPointAddress": "I55GwW_pickupPointAddress",
  "pickupPointName": "I55GwW_pickupPointName",
  "pickupPointRow": "I55GwW_pickupPointRow",
  "row": "I55GwW_row",
  "toggle": "I55GwW_toggle",
});
